import React from 'react'
import { useParams } from 'react-router-dom'

// styles & components
import './Project.css'
import Loading from '../../components/Loading/Loading';

// hooks
import { useDocument } from '../../Hooks/useDocument'
import ProjectSummary from './ProjectSummary';
import ProjectComments from './ProjectComments';

export default function Project() {
  const { id } = useParams()

  const { document, error } = useDocument('projects', id)

  if(error){
    return <div className='error'>{error}</div>
  }
  
  if(!document) {
    return <Loading />
  }

  return (
    <div className='project-details'>
      <ProjectSummary project={document}/>
      <ProjectComments project={document} />
    </div>
  )
}
